export default "__VITE_ASSET__URVg47FU__"